<template>
  <div>
    <v-text-field
      v-model="formData.kv"
      label="KV"
      outlined
      dense
      disabled
    ></v-text-field>

    <v-row class="mt-3">
      <v-col cols="12" md="3" sm="3">
        <v-text-field
          label="Nomor"
          v-model="thcFormData.nomor"
          outlined
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="3" sm="3">
        <v-text-field
          label="Jumlah"
          v-model="thcFormData.jumlah"
          outlined
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="5" sm="5">
        <v-text-field
          label="Keterangan"
          v-model="thcFormData.keterangan"
          @keydown.enter="addHandlingCharge"
          outlined
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="1" sm="1">
        <v-btn
          color="primary"
          class="white--text"
          :disabled="state.loading"
          @click="addHandlingCharge"
        >
          Add
        </v-btn>
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="data"
      :loading="state.loading"
      :items-per-page="15"
      class="elevation-1 mt-2"
      dense
    >
      <template v-slot:item.jumlah="{ item }">
        {{ formatCurrency(item.jumlah) }}
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn
          icon
          @click="deleteHandlingCharge(item.id)"
          :disabled="state.loading"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <THCModal :openModal="!formData.kv" @close-modal="fetchDataTHCKV" />

    <!-- Save Button -->
    <v-btn
      class="mx-2"
      fab
      dark
      right
      bottom
      fixed
      color="success"
      @click="resetInputTHC"
    >
      New
    </v-btn>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      state: {
        loading: false,
        noData: false
      },
      headers: [
        { text: "Nomor", value: "nomor" },
        { text: "Jumlah", value: "jumlah" },
        { text: "Keterangan", value: "keterangan" },
        { text: "Actions", value: "actions", sortable: false }
      ],
      formData: {
        kv: ""
      },
      thcFormData: {
        nomor: "",
        jumlah: 0,
        keterangan: ""
      },
      totalBiaya: 0,
      terbilang: "",
      data: [],
      months: [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember"
      ],
      days: ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"]
    };
  },
  components: {
    THCModal: () => import("@/components/TerminalHandlingCharge/THCModal.vue")
  },
  computed: {
    today() {
      let date = new Date();
      let day = date.getDay();
      let month = date.getMonth();
      let year = date.getFullYear();

      return `${this.days[day]}, ${date.getDate()} ${
        this.months[month]
      } ${year}`;
    },
    tgl_berangkat() {
      let date = new Date(this.data.tgl_berangkat);
      let day = date.getDay();
      let month = date.getMonth();
      let year = date.getFullYear();

      return `${this.days[day]}, ${date.getDate()} ${
        this.months[month]
      } ${year}`;
    }
  },
  watch: {
    "formData.kv"(val) {
      if (val) {
        this.formData.kv = val.toUpperCase();
      }
    }
  },
  methods: {
    async fetchDataTHCKV(val) {
      this.formData.kv = val.kv;
      this.data = val.thc;
    },
    async fetchData() {
      this.state.loading = true;

      axios
        .get(`thc?kv=${this.formData.kv}`)
        .then(res => {
          this.data = res.data.data.thc;
          this.state.loading = false;
        })
        .catch(err => {
          this.state.loading = false;
        });
    },
    async addHandlingCharge() {
      this.state.loading = true;

      axios
        .post(`thc?kv=${this.formData.kv}`, this.thcFormData)
        .then(res => {
          this.data = res.data.data.thc;
          console.log(res.data);
          this.state.loading = false;

          this.resetHandlingCharge();
        })
        .catch(err => {
          this.state.loading = false;
        });
    },
    async deleteHandlingCharge(id) {
      this.state.loading = true;

      axios
        .delete(`thc/${id}`)
        .then(res => {
          this.this.state.loading = false;

          this.fetchData();
        })
        .catch(err => {
          this.state.loading = false;
        });
    },
    resetHandlingCharge() {
      this.thcFormData = {
        nomor: "",
        jumlah: 0,
        keterangan: ""
      };
    },
    resetInputTHC() {
      this.formData = {
        kv: ""
      };

      this.data = [];
    },
    formatCurrency(num) {
      return new Intl.NumberFormat("id-ID").format(num);
    },
    convertToAngka(nilai) {
      if (nilai == "0" || nilai == "" || nilai == null) return 0;

      let desimal = nilai.split(",")[1];
      let angka = nilai
        .split(",")[0]
        .split(".")
        .join("");
      return parseFloat(`${angka}.${desimal}`);
    },
    pembilang(nilai) {
      const _isNominalValid = nilai => {
        const regex = new RegExp(/^\d+$/);
        return !regex.test(nilai);
      };
      const _nominalWording = nilai => {
        const UNIQUE_TWELVE = 12;
        const UNIQUE_TWENTY = 20;
        const UNIQUE_TWO_HUNDRED = 200;
        const UNIQUE_TWO_THOUSAND = 2000;
        const UNIQUE_NAMING = [
          "",
          "Satu ",
          "Dua ",
          "Tiga ",
          "Empat ",
          "Lima ",
          "Enam ",
          "Tujuh ",
          "Delapan ",
          "Sembilan ",
          "Sepuluh ",
          "Sebelas "
        ];
        const TEN = 10;
        const ONE_HUNDRED = 100;
        const ONE_THOUSAND = 1000;
        const ONE_MILLION = 1000000;
        const ONE_BILLION = 1000000000;
        const ONE_TRILLION = 1000000000000;
        if (nilai < ONE_HUNDRED) {
          if (nilai < UNIQUE_TWELVE) return UNIQUE_NAMING[nilai];
          if (nilai < UNIQUE_TWENTY)
            return _nominalWording(nilai % TEN) + "Belas ";
          return (
            _nominalWording(Math.floor(nilai / TEN)) +
            "Puluh " +
            _nominalWording(nilai % TEN)
          );
        }
        if (nilai < ONE_THOUSAND) {
          if (nilai < UNIQUE_TWO_HUNDRED)
            return "Seratus " + _nominalWording(nilai % ONE_HUNDRED);
          return (
            _nominalWording(Math.floor(nilai / ONE_HUNDRED)) +
            "Ratus " +
            _nominalWording(nilai % ONE_HUNDRED)
          );
        }
        if (nilai < ONE_MILLION) {
          if (nilai < UNIQUE_TWO_THOUSAND)
            return "Seribu " + _nominalWording(nilai % ONE_THOUSAND);
          return (
            _nominalWording(Math.floor(nilai / ONE_THOUSAND)) +
            "Ribu " +
            _nominalWording(nilai % ONE_THOUSAND)
          );
        }
        if (nilai < ONE_BILLION)
          return (
            _nominalWording(Math.floor(nilai / ONE_MILLION)) +
            "Juta " +
            _nominalWording(nilai % ONE_MILLION)
          );
        return (
          _nominalWording(Math.floor(nilai / ONE_BILLION)) +
          "Miliar " +
          _nominalWording(nilai % ONE_BILLION)
        );
      };
      if (_isNominalValid(nilai)) return "Nol Rupiah";

      return _nominalWording(nilai) + "Rupiah";
    }
  }
};
</script>

<style lang="css" scoped>
.report {
  background-color: white;
  width: 100%;
  font-family: times;
  padding: 20px;
  color: black;
}

.report .report-title {
  border-bottom: 1px solid black;
}

.header {
  display: flex;
  justify-content: space-between;
}

.header .left {
  width: 100%;
}

.header .right {
  width: 20%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.right p {
  font-size: 12px;
}

.report-info {
  display: flex;
  margin-top: 1rem;
  justify-content: space-between;
}

.report-info p {
  font-style: italic;
}

.report-info .kv {
  padding: 0 5px;
  height: fit-content;
  border: 1px solid black;
}

table {
  border-bottom: 1px solid black;
}

table th {
  text-align: left;
}

footer {
  display: flex;
  justify-content: space-between;
}

.sign p {
  margin-right: 150px;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
